"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.223 19.078l.526.235c.99.44 2.09.687 3.251.687a8 8 0 10-8-8c0 1.162.246 2.26.688 3.25l.234.527-.55 3.851 3.851-.55zm-6.208 2.907l.846-5.92A9.965 9.965 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a9.965 9.965 0 01-4.064-.86l-5.921.845z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;